import { useState, useEffect } from "react";
import { useRoutes } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { selectAdmin, addAmin } from "../redux/adminSlice";
import { ThemeRoutes } from "./ThemeRoutes";
import axios from "axios";
import LoadingOverlay from "../mui/LoadingOverlay";

const baseURL = import.meta.env.VITE_Backend_URL;

const PrivateRoutes = () => {
  const dispatch = useDispatch();
  const admin = useSelector(selectAdmin);
  const [isLoading, setIsLoading] = useState(!admin);
  const routing = useRoutes(ThemeRoutes(admin));

  useEffect(() => {
    const token = localStorage.getItem("lsh-token");
    if (!token) return; // No token case handled in render

    const fetchUserData = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/admin/getMe`, {
          headers: {
            "Authorization": `Bearer ${token}`
          },
        });

        if (response.status === 200) {
          dispatch(addAmin(response.data.data));
          // localStorage.setItem("lsh-token", response?.data?.data?.jwtAdminToken)
        } else {
          localStorage.removeItem("lsh-token");
        }
      } catch (err) {
        console.error("Error fetching user data:", err);
        localStorage.removeItem("lsh-token");
      } finally {
        setIsLoading(false);
      }
    };

    if (!admin) {
      fetchUserData();
    }
  }, [dispatch, admin]);

  const token = localStorage.getItem("lsh-token");
  if (!token) {
    return <Navigate to="/" replace />;
  }

  if (isLoading) {
    return <div className="dark">
      <LoadingOverlay open={isLoading} />

    </div>;
  }

  if (!admin) {
    return <Navigate to="/" replace />;
  }

  return <div className="dark">{routing}</div>;
};

export default PrivateRoutes;
